/** Shared count label formatter (e.g. "1 range", "2 components") — used by any collapsed-summary
 * badge across QualitySpecCard and its child panels. */
export const pluralize = (count: number, noun: string): string => `${count} ${noun}${count === 1 ? '' : 's'}`;
